var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoKt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 61.4 61.6",
    style: {
      enableBackground: "new 0 0 61.4 61.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F47E20;}\r\n\t.st1{fill:#808184;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.1,21.3c-0.4,0.4-0.4,1.1,0,1.5l20.6,20.5c0.4,0.4,0.8,0.3,0.8-0.3l0-42c0-0.6-0.3-0.7-0.8-0.3L40.1,21.3z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.3,61.6c0.6,0,0.7-0.3,0.3-0.8L31.4,31.5c-0.4-0.4-1.1-0.4-1.5,0L13,48.4c-0.4,0.4-0.8,0.3-0.8-0.3V32.9 c0-0.6,0.3-1.4,0.8-1.9L43.2,0.8C43.7,0.4,43.5,0,42.9,0H27.8c-0.6,0-1.4,0.3-1.9,0.8L13,13.7c-0.4,0.4-0.8,0.3-0.8-0.3V1.1 c0-0.6-0.5-1.1-1.1-1.1H1.1C0.5,0,0,0.5,0,1.1v59.3c0,0.6,0,1.1,0,1.1c0,0,0.5,0,1.1,0h15.1c0.6,0,1.4-0.3,1.9-0.8l11.9-11.9 c0.4-0.4,1.1-0.4,1.5,0l11.9,11.9c0.4,0.4,1.3,0.8,1.9,0.8H60.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoKt);
export default __webpack_public_path__ + "static/media/logo-kt.49eb24ef5ed7285c1bed8b62e39c1734.svg";
export { ForwardRef as ReactComponent };